<div class="page-container">
  <app-header></app-header>

  <div class="container">
    <div class="faq-img row">
      <div class="faq-khubii-head col-md-12 col-lg-12 mb-12">
        <h3 mat-title class="text-center mb-4 pb-2 faq-text-color fw-bold" style="font-size: 25px; letter-spacing: 2px;">
          FuProp FAQ
        </h3>
        <p mat-subtitle class="text-center" style="font-size: 20px;">
          Everything you need to know so that you can use FuProp with ease
        </p>
      </div>
      <!-- <div class="col-md-6 col-lg-6 mb-6">
        <img src="../../assets/images/faq-img.png" width="100%" alt="FAQ Image">
      </div> -->
    </div>

    <div class="p-5 row">
      <mat-accordion>
        <!-- General Questions Section -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fa fa-question-circle faq-text-color pe-2" style="color: #004aad;"></i>&nbsp;&nbsp;General Questions
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-body">
            <mat-list>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q1: What is FuProp?</strong><br>
                  A1: FuProp is an online real estate platform where users can buy, sell, or rent residential and commercial properties. We connect property owners, agents, and seekers all in one place.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q2: Is creating an account free?</strong><br>
                  A2: Yes, creating a basic account is completely free. Some premium features may require a paid subscription or listing fee.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q3: How do I contact support?</strong><br>
                  A3: You can contact our support team via the “Contact Us” page, or email at support@fuprop.com. We typically respond within 24 hours.
                </h4>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-expansion-panel>

        <!-- For Buyers Section -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fa fa-home faq-text-color pe-2" style="color: #004aad;"></i>&nbsp;&nbsp;For Buyers
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-body">
            <mat-list>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q1: How do I search for properties to buy?</strong><br>
                  A1: Simply enter your preferred location, budget, property type, and other filters into our search bar to see listings that match your criteria.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q2: Can I schedule a property visit?</strong><br>
                  A2: Yes! Use the "Schedule a Visit" button on the listing page to set up a tour with the owner or agent.
                </h4>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-expansion-panel>

        <!-- For Sellers Section -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fa fa-arrow-up faq-text-color pe-2" style="color: #004aad;"></i>&nbsp;&nbsp;For Sellers
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-body">
            <mat-list>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q1: How do I list my property for sale?</strong><br>
                  A1: After signing up, go to your dashboard and click “Post a Listing.” Enter your property details, upload photos, and publish the listing.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q2: Is there a fee to list my property?</strong><br>
                  A2: Basic listings are usually free, but we offer premium plans for better visibility and promotion.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q3: Can I edit or remove my listing later?</strong><br>
                  A3: Yes, you can manage all your listings from your account dashboard. You can edit, pause, or delete them anytime.
                </h4>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-expansion-panel>

        <!-- For Renters Section -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fa fa-building faq-text-color pe-2" style="color: #004aad;"></i>&nbsp;&nbsp;For Renters
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-body">
            <mat-list>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q1: How do I find properties for rent?</strong><br>
                  A1: Use the search filters to select "Rent" and enter your preferred location, price range, and amenities.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q2: Can I contact landlords directly?</strong><br>
                  A2: Yes, contact details are available on the listing page. You can also use the platform’s internal messaging system.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q3: Are rentals long-term or short-term?</strong><br>
                  A3: We offer both long-term and short-term rental options. Be sure to check the listing details for specific terms.
                </h4>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-expansion-panel>

        <!-- Safety & Verification Section -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fa-regular fa-shield faq-text-color pe-2" style="color: #004aad;"></i>&nbsp;&nbsp;Safety & Verification
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-body">
            <mat-list>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q1: How do I know if a listing is genuine?</strong><br>
                  A1: Look for listings with the “Verified” badge and always communicate through the platform. Avoid making payments before visiting the property.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q2: What should I do if I suspect a fake listing?</strong><br>
                  A2: Report the listing using contact support. We take user safety seriously and act quickly on reports.
                </h4>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-expansion-panel>

        <!-- Payments & Transactions Section -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fa fa-credit-card faq-text-color pe-2" style="color: #004aad;"></i>&nbsp;&nbsp;Payments & Transactions
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-body">
            <mat-list>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q1: Do you handle payments for purchases or rent?</strong><br>
                  A1: No, we do not handle financial transactions directly. All payments are handled between the buyer/seller or renter/landlord.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q2: Are there any hidden fees?</strong><br>
                  A2: We are transparent with all charges. Any applicable fees for premium services or advertising will be clearly listed during checkout.
                </h4>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-expansion-panel>

        <!-- Mobile App & Notifications Section -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fa-solid fa-mobile-retro faq-text-color pe-2" style="color: #004aad;"></i>&nbsp;&nbsp;Mobile App & Notifications
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-body">
            <mat-list>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q1: Do you have a mobile app?</strong><br>
                  A1: Yes! Our app is available on iOS and Android for easy browsing, listing, and communication on the go.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q2: How can I get alerts for new listings?</strong><br>
                  A2: You can set up custom alerts based on your search preferences. We’ll notify you via email or app push notifications.
                </h4>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-expansion-panel>

        <!-- For Agents & Agencies Section -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i class="fa fa-users faq-text-color pe-2" style="color: #004aad;"></i>&nbsp;&nbsp;For Agents & Agencies
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="accordion-body">
            <mat-list>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q1: Can real estate agents list properties?</strong><br>
                  A1: Absolutely. We offer special tools and dashboards tailored for real estate agents and agencies to manage multiple listings.
                </h4>
              </mat-list-item>
              <mat-list-item>
                <h4 mat-line class="faq-text-color">
                  <strong>Q1: Is there a partnership program?</strong><br>
                  A1: Yes, agents and agencies can join our Partner Program for additional exposure, branding, and marketing benefits.
                </h4>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-expansion-panel>

      </mat-accordion>
    </div>
  </div>

  <app-footer></app-footer>
</div>
